/** Borrador → Abierto → Cerrado → Completado, with what the next step means */

import { Check } from 'lucide-react';
import type { EventStatus } from '@/types/event.types';

const STEPS: { status: EventStatus; label: string }[] = [
  { status: 'DRAFT', label: 'Borrador' },
  { status: 'OPEN', label: 'Abierto' },
  { status: 'CLOSED', label: 'Cerrado' },
  { status: 'COMPLETED', label: 'Completado' },
];

const NEXT_HINT: Record<EventStatus, string> = {
  DRAFT: 'Siguiente paso: abrir las inscripciones para recibir inscritos y pagos.',
  OPEN: 'Siguiente paso: cerrar las inscripciones al terminar el plazo. Los pagos y la asistencia siguen habilitados.',
  CLOSED: 'Siguiente paso: marcar el evento como completado cuando termine.',
  COMPLETED: 'Evento finalizado: solo lectura.',
};

export function EventLifecycleStepper({ status }: { status: EventStatus }) {
  const current = STEPS.findIndex((s) => s.status === status);

  return (
    <div className="space-y-2 rounded-md border px-4 py-3">
      <ol className="flex items-center" aria-label="Estado del evento">
        {STEPS.map((step, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <li key={step.status} className="flex flex-1 items-center last:flex-none">
              <span className="flex items-center gap-2" aria-current={active ? 'step' : undefined}>
                <span
                  className={`flex size-6 items-center justify-center rounded-full border text-xs font-semibold ${
                    done
                      ? 'border-primary bg-primary text-primary-foreground'
                      : active
                        ? 'border-primary text-primary'
                        : 'border-border text-muted-foreground'
                  }`}
                >
                  {done ? <Check className="size-3.5" /> : i + 1}
                </span>
                <span className={`text-sm ${active ? 'font-semibold' : 'text-muted-foreground'}`}>{step.label}</span>
              </span>
              {i < STEPS.length - 1 && <span className={`mx-3 h-px flex-1 ${done ? 'bg-primary' : 'bg-border'}`} />}
            </li>
          );
        })}
      </ol>
      <p className="text-xs text-muted-foreground">{NEXT_HINT[status]}</p>
    </div>
  );
}
